
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';

import { useServerWebSocket } from '@/composables/useServerWebSocket';

import TheHeader from '@/components/TheHeader.vue';
import TheError from '@/components/TheError.vue';
import ServersTable from '@/components/ServersTable.vue';
import UpdateTime from '@/components/UpdateTime.vue';
import ServersCard from '@/components/ServersCard.vue';
import TheFooter from '@/components/TheFooter.vue';

export default defineComponent({
  name: 'App',
  components: {
    TheHeader,
    TheError,
    ServersTable,
    ServersCard,
    TheFooter,
    UpdateTime
  },
  setup() {
    // 外部注入 window.__PRE_CONFIG__
    const { interval, apiUrl, wsBaseUrl } = (window as any).__PRE_CONFIG__;

    const servers = ref<any[]>([]);
    const updated = ref<number>();
    let fallbackTimer: number | undefined;

    // 使用配置中的 wsBaseUrl 初始化 WebSocket 管理器
    const wsManager = useServerWebSocket(servers, wsBaseUrl);

    const initFetch = async () => {
      try {
        // 使用配置中的 apiUrl 进行初始请求
        const res = await axios.get(apiUrl);
        servers.value = res.data.servers;
        updated.value = Number(res.data.updated);

        // 为每个服务器建立 WebSocket 连接
        servers.value.forEach((server: any) => {
          const connectId = server.id || server.name;
          wsManager.connect(connectId, server.name);
        });

      } catch (err) {
        const errorMsg = `初始数据获取失败！\n请检查配置文件config.js中的 apiUrl 是否正确。\n当前配置: ${apiUrl}`;
        alert(errorMsg); // 弹窗提醒用户
        console.error(errorMsg, err);
        startFallbackPolling(); // 继续尝试降级轮询
      }
    };

    // 降级轮询方案
    const startFallbackPolling = () => {
      const runFetch = () => {
        axios.get(apiUrl)
            .then(res => {
              servers.value = res.data.servers;
              updated.value = Number(res.data.updated);
            })
            .catch(err => console.log('Fallback polling error:', err));
      };
      runFetch();
      fallbackTimer = window.setInterval(runFetch, interval * 1000);
    };

    onMounted(() => {
      initFetch();
    });

    onBeforeUnmount(() => {
      if (fallbackTimer) clearInterval(fallbackTimer);
      wsManager.disconnectAll();
    });

    return {
      servers,
      updated
    };
  }
});
